import { Icon, IconButton, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';
import EditEntityDialog from '../dialogs/EditEntityDialog';
const StyledDiv = styled.div `
  display: flex;
  align-items: center;
  .edit-button {
    margin-left: 8px;
  }
`;
const EntityNameHeader = ({ entity }) => {
    const [openDialog, setOpenDialog] = useState(false);
    return (React.createElement(StyledDiv, null,
        React.createElement(Typography, { variant: 'h5', className: 'header-label' },
            "Entity: ",
            (entity === null || entity === void 0 ? void 0 : entity.displayName) || ''),
        React.createElement(IconButton, { size: 'small', className: 'edit-button', onClick: () => setOpenDialog(true) },
            React.createElement(Icon, null, "settings")),
        openDialog && (React.createElement(EditEntityDialog, { open: true, entity: entity, onCancel: () => setOpenDialog(false), onEdited: () => setOpenDialog(false) }))));
};
export default EntityNameHeader;
//# sourceMappingURL=EntityNameHeader.js.map